import { useSelector } from 'react-redux'
import { allEntryTypesSelector } from 'apps/formsCreationKit/store/selectors/types'
import {
  activeEntrySelector,
  tableCalculationScreenAndEntriesSelector,
} from 'apps/formsCreationKit/store/selectors/entities'
import {
  LabelInput,
  EntryTypeSelect,
  BothHideToggles,
  StandardDesignConfig,
  HideOnPdfToggle,
} from 'apps/studio/components/settings/fields/Base/standard'
import { lib } from '@gocanvas/client'
const { CALCULATION_ORIGINAL_TYPE_ID, SUM_ORIGINAL_TYPE_ID } = lib

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'  

const CalculationTypeRadioButton = {
  label: 'Calculation Type',
  settingType: 'radioButton',
  property: 'original_type_id',
  updateType: 'entry',
  dynamicChoices: () => {
    const activeEntry = useSelector(activeEntrySelector)
    const entryTypes = useSelector(allEntryTypesSelector)
    const { id: calculationEntryTypeId, ...calculationEntryType } =
      entryTypes.find(({ type }) => type === 'Calculation')
    const {
      id: sumEntryTypeId,
      label,
      ...sumEntryType
    } = entryTypes.find(({ type }) => type === 'Sum')

    return [
      {
        label: 'Calculation',
        value: CALCULATION_ORIGINAL_TYPE_ID,
        additionalProperties: {
          ...activeEntry,
          ...calculationEntryType,
          entry_type_id: calculationEntryTypeId,
        },
      },
      {
        label: 'Sum',
        value: SUM_ORIGINAL_TYPE_ID,
        additionalProperties: {
          ...activeEntry,
          ...sumEntryType,
          entry_type_id: sumEntryTypeId,
        },
      },
    ]
  },
  showInput: () => {
    const entryTypes = useSelector(allEntryTypesSelector)
    const calculationEntryType = entryTypes.find(
      ({ type }) => type === 'Calculation'
    )
    const sumEntryType = entryTypes.find(({ type }) => type === 'Sum')
    return calculationEntryType && sumEntryType
  },
}

const SumTableColumnSelect = {
  label: 'Sum Field',
  settingType: 'sheetEntrySelect',
  property: 'summary_entry',
  nestedProp: 'guid',
  updateType: 'entry',
  tooltip:
    'Choose the field you want to sum up values for. Works best with table, list, or loop screens.',
  dynamicChoices: () => {
    const tableScreenAndEntries = useSelector(
      tableCalculationScreenAndEntriesSelector
    )
    const options = tableScreenAndEntries.map(({ sheet, entries }) => ({
      label: sheet.description || sheet.placeholder,
      options: entries.map(({ guid, label, type }) => ({
        value: guid,
        label,
        type,
        sheet,
      })),
    }))

    return options
  },
  isDisabled: () => {
    const tableScreenAndEntries = useSelector(
      tableCalculationScreenAndEntriesSelector
    )
    const validEntries = tableScreenAndEntries.flatMap(({ entries }) => entries)

    return validEntries.length === 0
  },
}

const FormatSelect = ({ useExtendedOptions }) => ({
  label: 'Format',
  settingType: 'selectInput',
  updateType: 'entry',
  property: 'style',
  groupedOptions: useExtendedOptions,
  matchByAdditionalProperty: useExtendedOptions ? 'mask' : null,
  dynamicChoices: () => {
    const options = [
      { label: 'Number', value: 0 },
      { label: 'HH:MM', value: 1 },
      { label: 'HH:MM:SS', value: 2 },
      { label: 'MM:SS', value: 3 },
      { label: 'Currency', value: 4 },
    ]

    const extendedOptions = [
      {
        label: 'Number',
        options: [
          {
            label: '1',
            value: '0',
            additionalProperties: { mask: '0' },
          },
          {
            label: '1.0',
            value: '0',
            additionalProperties: { mask: '1' },
          },
          {
            label: '1.00',
            value: '0',
            additionalProperties: { mask: '2' },
          },
          {
            label: '1.000',
            value: '0',
            additionalProperties: { mask: '3' },
          },
          {
            label: '1.0000',
            value: '0',
            additionalProperties: { mask: '4' },
          },
          {
            label: '1.00000',
            value: '0',
            additionalProperties: { mask: '5' },
          },
          {
            label: '1.000000',
            value: '0',
            additionalProperties: { mask: '6' },
          },
        ],
      },
      {
        label: 'Time',
        options: [
          {
            label: 'HH:MM',
            value: 1,
            additionalProperties: { mask: '0' },
          },
          {
            label: 'HH:MM:SS',
            value: 2,
            additionalProperties: { mask: '0' },
          },
          {
            label: 'MM:SS',
            value: 3,
            additionalProperties: { mask: '0' },
          },
        ],
      },
      {
        label: 'Currency',
        options: [
          {
            label: 'Currency',
            value: 4,
            additionalProperties: { mask: '2' },
          },
        ],
      },
    ]

    return useExtendedOptions ? extendedOptions : options
  },
})

export const CalculationStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'),
  FormatSelect({ useExtendedOptions: true }),
  ...StandardDesignConfig,
  HideOnPdfToggle,
  // ...BothHideToggles,
  // CalculationTypeRadioButton,

]

export const SumStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'),
  FormatSelect({ useExtendedOptions: false }),
  ...StandardDesignConfig,
  HideOnPdfToggle,
  // ...BothHideToggles,
  // CalculationTypeRadioButton,
  // SumTableColumnSelect,
]
